// extracted by mini-css-extract-plugin
export default {"back":"overlayBackButton__back__Q_Pni"};